
import React from 'react';
import { Container, Row } from 'reactstrap';

// Simple component without Flow types
const Auth = ({ children }) => {
    return (
        <div className="account-pages">
            <Container>
                <Row className="justify-content-center">
                    {children}
                </Row>
            </Container>
        </div>
    );
};

export default Auth;
